import { useEffect, useMemo, useState } from 'react';
import { api, imageUrl } from './api';

// Đổi ảnh danh mục: hiện ảnh hiện tại, chọn ảnh mới xem trước rồi mới lưu
export default function CategoryImageDialog({ category, onDone, onCancel }) {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const preview = useMemo(() => (file ? URL.createObjectURL(file) : ''), [file]);
  useEffect(() => () => preview && URL.revokeObjectURL(preview), [preview]);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      await api.uploadCategoryImage(category.id, file);
      await onDone();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="dialog-backdrop" onClick={saving ? undefined : onCancel}>
      <form className="dialog image-dialog" onClick={(e) => e.stopPropagation()} onSubmit={save} aria-label="Đổi ảnh danh mục">
        <h2>Đổi ảnh "{category.name}"</h2>

        <div className="image-compare">
          <div className="field">
            Ảnh hiện tại
            <div className="image-box">
              {category.imageUrl ? <img src={imageUrl(category.imageUrl, 500)} alt="Ảnh hiện tại" /> : <span>Chưa có ảnh</span>}
            </div>
          </div>
          <div className="field">
            Ảnh mới
            <label className={`image-box image-pick ${preview ? 'has-image' : ''}`}>
              {preview ? <img src={preview} alt="Ảnh mới" /> : <span>+ Chọn ảnh</span>}
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => {
                  setFile(e.target.files[0] || null);
                  e.target.value = '';
                }}
              />
            </label>
          </div>
        </div>

        {error && <p className="error">{error}</p>}

        <div className="dialog-actions">
          <button type="button" onClick={onCancel} disabled={saving}>
            Huỷ
          </button>
          <button type="submit" className="primary" disabled={saving || !file}>
            {saving ? 'Đang lưu...' : 'Lưu ảnh mới'}
          </button>
        </div>
      </form>
    </div>
  );
}
